import { ReactNode } from 'react';
import { GridProps as MuiGridProps } from '@mui/material/Grid';
import {
  StyledContainer,
  StyledLeftColumn,
  StyledRightColumn,
  StyledWrapper,
} from './styles';
import StickyColumn from './StickyColumn';

export enum LayoutVariants {
  full = 'full',
  '50/50' = '50/50',
  '70/30' = '70/30',
  '80/20' = '80/20',
}

export interface PageLayoutProps extends Omit<MuiGridProps, 'title'> {
  variant?: keyof typeof LayoutVariants;
  rightContent?: ReactNode;
  divider?: boolean;
  stickyRightColumn?: boolean;
  stickyTopOffset?: number;
}

export default function PageLayout(props: PageLayoutProps) {
  const {
    variant = LayoutVariants['80/20'],
    divider,
    rightContent,
    stickyRightColumn,
    stickyTopOffset,
    children,
    ...pageLayoutProps
  } = props;

  const leftColumnGrid = {
    [LayoutVariants.full]: {
      xs: 12,
    },
    [LayoutVariants['50/50']]: {
      xs: 12,
      md: 6,
    },
    [LayoutVariants['70/30']]: {
      xs: 12,
      md: 8,
    },
    [LayoutVariants['80/20']]: {
      xs: 12,
      md: 8.5,
    },
  };

  const rightColumnGrid = {
    [LayoutVariants.full]: {
      xs: 12,
    },
    [LayoutVariants['50/50']]: {
      xs: 12,
      md: 6,
    },
    [LayoutVariants['70/30']]: {
      xs: 12,
      md: 4,
    },
    [LayoutVariants['80/20']]: {
      xs: 12,
      md: 3.5,
    },
  };

  const fullSize = variant === LayoutVariants.full;
  const noPadding = fullSize || !rightContent;

  return (
    <StyledWrapper>
      <StyledContainer container {...pageLayoutProps}>
        <StyledLeftColumn
          item
          divider={divider}
          noPadding={noPadding}
          {...leftColumnGrid[variant]}
        >
          {children}
        </StyledLeftColumn>
        {!fullSize && (
          <StyledRightColumn
            item
            noPadding={noPadding}
            zeroMinWidth
            {...rightColumnGrid[variant]}
          >
            {stickyRightColumn ? (
              <StickyColumn stickyTopOffset={stickyTopOffset}>
                {rightContent}
              </StickyColumn>
            ) : (
              rightContent
            )}
          </StyledRightColumn>
        )}
      </StyledContainer>
    </StyledWrapper>
  );
}
